import { authSagas } from "./auth/sagas";
import {
  connectionStatusListenerSaga,
  connectionSagas,
} from "./connection/sagas";
import { reloadDeletedDevicesSaga } from "./deleted-devices/sagas";
import {
  deviceStatusInitSaga,
  deviceStatusListenerSaga,
} from "./device-statuses/sagas";
import { deviceSagas } from "./devices/sagas";
import { featureFlagsSagas } from "./feature-flags/sagas";
import { networkSagas } from "./networks/sagas";
import { tasksSaga } from "./tasks/sagas";
import { globalPageSagas } from "./ui-state";
import { userContentSagas } from "./user-contents/sagas";
import { forgotPasswordSaga, resetPasswordSaga } from "./users/sagas";

// These will be loaded across all apps.
const rootSagas = [
  connectionStatusListenerSaga(),
  deviceStatusInitSaga(),
  deviceStatusListenerSaga(),
  forgotPasswordSaga(),
  reloadDeletedDevicesSaga(),
  resetPasswordSaga(),
  tasksSaga(),
  ...authSagas,
  ...connectionSagas,
  ...deviceSagas,
  ...globalPageSagas,
  ...networkSagas,
  ...userContentSagas,
  ...featureFlagsSagas,
];

export { rootSagas };
